import { usePushNotificationState } from './usePushNotificationState';
import useAuth from '../../auth/authContext';
import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import useApi from '../../api/backendApiContext';

export const usePushNotificationTokenSync = () => {
  const { state } = usePushNotificationState();
  const {
    state: { user },
  } = useAuth();

  const { pushNotificationsApi } = useApi();

  const { mutate: updatePushNotificationToken } = useMutation(async () => {
    if (!state || !user || !state.expoPushToken) return;

    if (state.status === 'granted') {
      await pushNotificationsApi.setExpoPushToken(user.userId, state.expoPushToken);
    } else {
      await pushNotificationsApi.disablePushNotifications(user.userId, state.expoPushToken);
    }
  });

  useEffect(
    () => updatePushNotificationToken(),
    [state?.expoPushToken, state?.status, user?.userId, updatePushNotificationToken]
  );
};
